module.exports = __webpack_public_path__ + "img/delivery_address.f2982bd3.svg";